module.exports = __webpack_public_path__ + "static/media/close-light.11e4ec23.svg";